const { isDate } = require("./datetimeUtils");

function binarySearchDate(arr, targetDate, findStart = true) {
    let left = 0;
    let right = arr.length - 1;

    let preLeftRight = -1;

    while (left <= right) {
        if (preLeftRight === left + right) {
            return findStart ? left : right;
        }
        preLeftRight = left + right;
        let mid = Math.floor((left + right) / 2);

        let midDate = roundToNearestFiveMinutes(new Date(arr[mid])); // Convert to Date for comparison        
        let preMidDate = roundToNearestFiveMinutes(new Date(arr[mid + (findStart ? -1 : 1)])); // Convert to Date for comparison
        if (findStart) {
            if (targetDate.getTime() > preMidDate.getTime() && targetDate.getTime() <= midDate.getTime()) {
                return mid;
            } else if (targetDate.getTime() > midDate.getTime()) {
                left = mid + 1;
            } else if (targetDate.getTime() < midDate.getTime()) {
                right = mid - 1;
            } else {
                return 0;
            }
        } else { // end date
            if (targetDate.getTime() <= preMidDate.getTime() && targetDate.getTime() >= midDate.getTime()) {
                return mid + 1;
            } else if (targetDate.getTime() < midDate.getTime()) {
                right = mid - 1;
            } else if (targetDate.getTime() > midDate.getTime()) {
                left = mid + 1;
            } else {
                return arr.length - 1;
            }
        }
    }
    return findStart ? left : right;
}

function roundToNearestFiveMinutes(date) {
    const minutes = date.getMinutes();

    // Round to nearest multiple of 5
    const roundedMinutes = Math.round(minutes / 5) * 5;

    // Set the rounded minutes and reset seconds/milliseconds
    date.setMinutes(roundedMinutes, 0, 0);

    return date;
}
function roundToTwoDigits(num) {
    if (num === 0) return 0; // Ensure -0 becomes 0
    if (Number.isNaN(num)) {
        return 0;
    }    
    return parseFloat(num.toFixed(2));
}

function timeArrays({ timeRange = [], valueArray = [], startDate, endDate, filter }) {
    const results = [];
    try {
        if (!timeRange?.length) {
            return []
        }        
        const endIndex = binarySearchDate(timeRange, roundToNearestFiveMinutes(endDate), false);
        const startIndex = binarySearchDate(timeRange, roundToNearestFiveMinutes(startDate), true);
        for (let i = startIndex; i <= endIndex && i < timeRange.length; i++) {
            const item = {
                date: isDate(timeRange[i]) ? timeRange[i] : roundToNearestFiveMinutes(new Date(timeRange[i])),
                value: roundToTwoDigits(valueArray[i])
            };
            if (true || !filter || filter(item)) {
                results.push(item);
            } else {
                break;
            }
        }
    } catch (err) {
        
    }
    return results;
}

module.exports = {
    timeArrays,
    roundToNearestFiveMinutes,
    roundToTwoDigits
}